import React from "react";

const TenementsLegend = () => {
  const legendEntryStyle = { display: "flex" };

  return (
    <div className="tenementsLegend">
      Tenements Legend
      <div style={legendEntryStyle}>
        <div className="TenementLegendSwatch" style={{ backgroundColor: "#f46d43" }}></div>Exploration
      </div>
      <div style={legendEntryStyle}>
        <div className="TenementLegendSwatch" style={{ backgroundColor: "#fdae61" }}></div>Prospecting
      </div>
      <div style={legendEntryStyle}>
        <div className="TenementLegendSwatch" style={{ backgroundColor: "#fee08b" }}></div>Mining
      </div>
      <div style={legendEntryStyle}>
        <div className="TenementLegendSwatch" style={{ backgroundColor: "#ffffbf" }}></div>Misc
      </div>
      <div style={legendEntryStyle}>
        <div className="TenementLegendSwatch" style={{ backgroundColor: "#e6f598" }}></div>General Purpose
      </div>
      <div style={legendEntryStyle}>
        <div className="TenementLegendSwatch" style={{ backgroundColor: "#abdda4" }}></div>Mineral Claim
      </div>
      <div style={legendEntryStyle}>
        <div className="TenementLegendSwatch" style={{ backgroundColor: "#3288bd" }}></div>Other
      </div>
    </div>
  );
};

export default TenementsLegend;
